import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { NavBar } from "@/components/NavBar";
import { Hero } from "@/components/Hero";
import { AlessandroSection } from "@/components/AlessandroSection";
import { WorkshopsSection } from "@/components/WorkshopsSection";
import { ReviewsSection } from "@/components/ReviewsSection";
import { InstagramSection } from "@/components/InstagramSection";
import { InstagramCTA } from "@/components/InstagramCTA";
import { Footer } from "@/components/Footer";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="bg-[#050505] text-white">
      <NavBar />
      <Hero />
      <AlessandroSection />
      <WorkshopsSection />
      <ReviewsSection />
      <InstagramSection />
      <InstagramCTA />
      <Footer />
    </div>
  );
}
